import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[tihOverlayComponent]'
})
export class OverlayComponentDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
